import Phaser from "phaser";
import { config } from "@/config";
import { getZoneConfig } from "@/world/map/ZoneManifest";

export const ZONE_SCENE_KEY = "ZoneScene";
export const SIDESCROLL_SCENE_KEY = "SideScrollScene";

/**
 * Pick the scene class that should host a given zone, based on its projection.
 * Side-scroll lives in its own scene; everything else (iso/topdown/oblique)
 * shares ZoneScene with a Projection strategy injected.
 */
export function sceneKeyFor(scene: Phaser.Scene, zoneId: string): string {
  try {
    const cfg = getZoneConfig(scene, zoneId);
    return cfg.projection === "sidescroll" ? SIDESCROLL_SCENE_KEY : ZONE_SCENE_KEY;
  } catch {
    return ZONE_SCENE_KEY;
  }
}

/**
 * Travel to a zone. Restarts the current scene if the target zone uses the
 * same scene class; otherwise stops the current scene and starts the other.
 * Mutates `config.zoneId` so reconnect logic in the new scene picks it up.
 */
export function routeToZone(
  scene: Phaser.Scene,
  zoneId: string,
  targetSpawn: [number, number],
): void {
  config.zoneId = zoneId;
  const targetSceneKey = sceneKeyFor(scene, zoneId);
  if (scene.scene.key === targetSceneKey) {
    scene.scene.restart({ targetSpawn });
  } else {
    scene.scene.start(targetSceneKey, { targetSpawn });
  }
}
